import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Legal.css';

export default function Disclaimer() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-container">
      <div className="legal-section">
        <h1>Disclaimer</h1>
  
        <div className="disclaimer-warning">
          <h2>⚠️ Important Risk Warning</h2>
          <p>Before participating in BreakMe.ai™, please carefully read and acknowledge the following:</p>
          <ul>
            <li>All payments, token purchases, and game transactions are final and non-refundable</li>
            <li>Cryptocurrencies carry extreme risk and is not suitable for all participants</li>
            <li>The game token is a utility token for gameplay only, not an investment vehicle</li>
            <li>You may lose all funds used to purchase tokens and/or participate in the game</li>
          </ul>
        </div>

        <section>
          <h2>Financial Risks & Cryptocurrency Warning</h2>
          <p>The cryptocurrency market is highly volatile and unpredictable. Historical data shows that the vast majority of retail traders experience significant losses. Any purchases associated with this game should be considered at risk of becoming worthless. Never invest more than you can afford to lose entirely.</p>
        </section>

        <section>
          <h2>Game Mechanics & Token Usage</h2>
          <p>Tokens within BreakMe.ai™ are designed exclusively for gameplay purposes, including but not limited to making attempts, earning rewards, and participating in game mechanics. These tokens have no guaranteed value outside the game ecosystem.</p>
          <p>While tokens may be tradeable on various platforms, this is incidental and a feature of technology used, as to their primary purpose as game utility tokens. The development team makes no guarantees regarding token value, liquidity, or trading availability.</p>
        </section>

        <section>
          <h2>Game Participation Risks</h2>
          <p>Participation in the Game involves inherent risks, including potential financial loss. By participating, you acknowledge these risks and agree that BreakMe.ai assumes no responsibility for your actions or their consequences.</p>
        </section>

        <section>
          <h2>Contact Information</h2>
          <p>If you have any questions about this Disclaimer, the Privacy Policy, or the Terms of Use, please contact us via our official Telegram channels.</p>
        </section>
      </div>

      <div className="legal-footer">
        <Link to="/" className="nes-btn is-primary">
          🎮 Return to Game
        </Link>
      </div>
    </div>
  );
} 